import React, { useEffect } from "react";
import { Button, Card, Col, Flex, Form, Input, Row, Select, Typography } from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import styles from "./PricingModel.module.scss";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { useDispatch, useSelector } from "react-redux";
import { updatePlatformComissionPercentageAction } from "../../../../../../redux/services/configuration/configurationServices";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { colors } from "../../../../../../constants/colors";
import { MoneyCollectOutlined } from "@ant-design/icons";
import Spinner from "../../../../../common/spinner/Spinner";

const PricingModel = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  const dispatch = useDispatch();

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const initialValues = {
    platform_commission_percentage:""
  };

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);

  const handleGetTableData = () => {
    dispatch(getSystemSettingsAction(setLoading));
  }

  useEffect(()=>{
    handleGetTableData()
  },[])
  /* form dependencies */

  /* reset default form fields */
  const resetDefaultFields = () => {
    form.setFieldsValue({
      platform_commission_percentage:initialValues.platform_commission_percentage
    });
  }
  /* reset default form fields */

  const alyanaShareDetails = [
    {
      title:t("Modules.PricingModel.alyanaShareText"),
      commission_percentage:systemSettings?.platform_commission_percentage
    }
  ]

  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values
    }

    dispatch(updatePlatformComissionPercentageAction(dataToBeSent, setLoading)).then(()=>{
      handleGetTableData();
    })
    resetDefaultFields()
  };

  return (
    <div className={styles.pricingModelContainer}>
      {
        loading ? <Spinner/>
        :
      <Flex vertical gap="2rem">
      {
          alyanaShareDetails?.map((element)=>{
            return (
            <Card
              bordered
              hoverable
              style={{ width: 300, padding: 0, borderRadius: 20, 
                border:`1px solid ${colors.DarkMint}` }}
            >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={8}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<MoneyCollectOutlined style={{ fontSize: 22 }} />}
                    style={{background:colors.DarkMint}}
                  />
                </Col>
                <Col span={16}>
                  <Flex vertical>
                    <Typography.Title level={3} style={{ color: colors.oceanBlue }}>
                      {element.title}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.oceanBlue }}
                    >
                      {`${element?.commission_percentage} %`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>
            )
          })
        }
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          style={{ maxWidth: "400px" }}
          onFinish={onSubmit}
        >
          <Form.Item
            name="platform_commission_percentage"
            label={
              <RequiredLabel
                text={t("Modules.PricingModel.alyanaShare")}
                required={true}
              />
            }
            rules={[
              {
                required: true,
                message: t("Modules.PricingModel.pleaseEnterAlyanaShare"),
              },
              {
                validator: (_, value) => {
                  if (value && value > 100) {
                    return Promise.reject(
                      `${t("Modules.PricingModel.alyanaShare")} ${t(
                        "CommonUtils.shouldNotBeGreaterThan100"
                      )}`
                    );
                  } else if (value && value < 1) {
                    return Promise.reject(
                      `${t("Modules.PricingModel.alyanaShare")} ${t(
                        "CommonUtils.shouldBeGreaterThan0"
                      )}`
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              type="number"
              placeholder={t("Modules.PricingModel.enterAlyanaShare")}
              onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
            />
          </Form.Item>

          {/* <Form.Item
              name="providerShare"
                label={<RequiredLabel text={t("Modules.PricingModel.providerShare")} required={true}/>}
                rules={[
                  {
                    required: true,
                    message: t("Modules.PricingModel.pleaseEnterProviderShare"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.PricingModel.pleaseEnterProviderShare"),
                  }
                ]}
              >
                <Input placeholder={t("Modules.PricingModel.enterProviderShare")}/>
              </Form.Item> */}

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={loading}
            style={{ marginTop: "10px" }}
          >
            {t("CommonUtils.submit")}
          </Button>
        </Form>
      </Flex>
      }
    </div>
  );
};

export default PricingModel;
